import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FolderSummary } from '@features/dashboard/mon-stock/models/folder.model';
import { UrlConfig } from '@shared/config/url.config';
import { AppSourceEnum } from 'pu-core-library';

@Injectable({
  providedIn: 'root',
})
export class FactureService {
  billSummaryUrl = `${UrlConfig.urlRemboursement}recapitulatifs`;

  constructor(private http: HttpClient) { }

  getBillsSummary(sirets: string[] | number[]): Observable<FolderSummary> {
    const body = {
      sirets: sirets,
      type: AppSourceEnum.POF,
    };

    return this.http.post<FolderSummary>(this.billSummaryUrl, body);
  }
}